/*
  TRC LPs, Google Ads October 2026 (templates/page.trclp-*). Vanilla JS, no dependencies.
  - Add to bag: through the theme's Liquid Ajax Cart (sections/ajax-cart.liquid), which refreshes the drawer and the
    item count and opens the drawer on a successful "add". Without it: POST /cart/add.js, then go to /cart.
    Without JS the forms post to /cart/add natively.
  - Variant chips, button states (loading / added / sold out), GTM dataLayer event, sticky bar, in-page anchors.
*/
(function () {
  'use strict';

  var root = document.querySelector('.trclp');
  if (!root) return;

  var LP = root.getAttribute('data-lp-trclp') || '';
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var html = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Variant chips ---------- */
  function selectChip(chip) {
    var form = chip.closest('[data-buy-trclp]');
    if (!form || chip.disabled) return;
    form.querySelectorAll('.vchip-trclp').forEach(function (c) {
      c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
    });
    form.querySelector('input[name="id"]').value = chip.getAttribute('data-variant-trclp');
    var btn = form.querySelector('[data-atc-trclp]');
    if (btn) btn.setAttribute('data-amount-trclp', chip.getAttribute('data-amount-trclp'));
    var scope = chip.closest('[data-product-trclp]');
    var out = scope && scope.querySelector('[data-price-out-trclp]');
    if (out) {
      var compare = chip.getAttribute('data-compare-trclp');
      out.innerHTML = esc(chip.getAttribute('data-price-trclp')) + (compare ? '<s>' + esc(compare) + '</s>' : '');
    }
  }

  /* ---------- Add to bag ---------- */
  function setButton(btn, state) {
    var label = btn.getAttribute('data-label-trclp') || 'Add to bag';
    btn.classList.remove('is-loading-trclp', 'is-added-trclp');
    btn.removeAttribute('aria-busy');
    if (state === 'loading') {
      btn.classList.add('is-loading-trclp');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
    } else if (state === 'added') {
      btn.classList.add('is-added-trclp');
      btn.textContent = 'Added ✓';
      setTimeout(function () { setButton(btn, 'idle'); }, 2500);
    } else if (state === 'soldout') {
      btn.classList.add('is-soldout-trclp');
      btn.disabled = true;
      btn.textContent = 'Sold out';
    } else {
      btn.textContent = label;
    }
  }

  function pushDataLayer(form, variantId, btn) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    window.dataLayer.push({
      event: 'trclp_add_to_cart',
      lp: LP,
      product_handle: form.getAttribute('data-handle-trclp'),
      variant_id: variantId,
      price: parseFloat(btn.getAttribute('data-amount-trclp')) || 0
    });
  }

  function add(form) {
    var btn = form.querySelector('[data-atc-trclp]');
    var msg = form.querySelector('.buy-msg-trclp');
    if (!btn || btn.disabled || btn.classList.contains('is-loading-trclp')) return;
    var variantId = Number(form.querySelector('input[name="id"]').value);
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (msg) msg.textContent = '';
    setButton(btn, 'loading');

    function done(ok, errText, status) {
      if (ok) {
        setButton(btn, 'added');
        pushDataLayer(form, variantId, btn);
        return;
      }
      if (status === 422 && /sold out|not available|unavailable/i.test(errText || '')) {
        setButton(btn, 'soldout');
      } else {
        setButton(btn, 'idle');
      }
      if (msg) msg.textContent = errText || 'Something went wrong. Please try again.';
    }

    var lac = window.liquidAjaxCart;
    if (lac && typeof lac.add === 'function') {
      lac.add(body, {
        lastCallback: function (requestState) {
          var r = requestState && requestState.responseData;
          var b = (r && r.body) || {};
          done(!!(r && r.ok), b.description || b.message, r && r.status);
        }
      });
      return;
    }

    fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }); })
      .then(function (r) {
        if (r.ok) {
          pushDataLayer(form, variantId, btn);
          window.location.href = ROOT_URL + 'cart';
        } else {
          done(false, r.body && (r.body.description || r.body.message), r.status);
        }
      })
      .catch(function () { form.submit(); });
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('.vchip-trclp');
    if (chip && root.contains(chip)) {
      e.preventDefault();
      selectChip(chip);
      return;
    }

    var cartLink = e.target.closest('[data-cart-open-trclp]');
    if (cartLink) {
      e.preventDefault();
      html.classList.toggle('js-ajax-cart-open');
      return;
    }

    /* In-page anchors: smooth scroll inside the LP only (no global html { scroll-behavior }) */
    var a = e.target.closest('a[href^="#"]');
    if (a && root.contains(a)) {
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
    }
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-buy-trclp]');
    if (!form) return;
    e.preventDefault();
    add(form);
  });

  /* ---------- Bag count badge (hide at 0) ---------- */
  var cartLink = root.querySelector('[data-cart-open-trclp]');
  document.addEventListener('liquid-ajax-cart:request-end', function () {
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (cartLink && cart) cartLink.setAttribute('data-count-trclp', cart.item_count);
  });

  /* ---------- Sticky bar (M5): hidden while the shop grid is on screen and while the cart drawer is open ---------- */
  var sticky = root.querySelector('[data-sticky-trclp]');
  var shop = document.getElementById('shop-trclp');
  if (sticky) {
    var inShop = false;
    var cartOpen = html.classList.contains('js-ajax-cart-open');
    var update = function () {
      var hide = inShop || cartOpen;
      sticky.classList.toggle('is-hidden-trclp', hide);
      sticky.setAttribute('aria-hidden', hide ? 'true' : 'false');
    };
    if (shop && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inShop = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(shop);
    }
    new MutationObserver(function () {
      cartOpen = html.classList.contains('js-ajax-cart-open');
      update();
    }).observe(html, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  /* ---------- Klaviyo: no popup / flyout / full-screen forms or teasers on the LPs ----------
     klaviyo.js keeps loading (onsite tracking, identify). Embedded forms are left alone.
     layout/theme.liquid hides these from the first paint; here they are removed as they appear,
     and Klaviyo's body scroll lock is never left on the page. */
  var KL_FORMS = '[role="dialog"][aria-label="POPUP Form"],[role="dialog"][aria-label="FLYOUT Form"],[role="dialog"][aria-label="FULL_SCREEN Form"],' +
    '[data-testid="POPUP"],[data-testid="FLYOUT"],[data-testid="FULL_SCREEN"],[class*="kl-teaser"]';
  var klQueued = false;
  function blockKlaviyo() {
    klQueued = false;
    document.querySelectorAll(KL_FORMS).forEach(function (el) {
      if (root.contains(el)) return;
      var top = el;
      while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
      // Remove Klaviyo's own top-level container; anything else, only the form element itself
      var klContainer = top.parentElement === document.body && top.id.indexOf('shopify-section') !== 0 &&
        (/kl-private-reset-css/.test(top.className) || top.querySelector('[class*="kl-private-reset-css"]'));
      (klContainer ? top : el).remove();
    });
    [document.body, html].forEach(function (n) {
      n.classList.remove('klaviyo-prevent-body-scrolling');
      if (n.style.overflow === 'hidden') n.style.overflow = '';
    });
  }
  function queueKlaviyo() {
    if (!klQueued) { klQueued = true; requestAnimationFrame(blockKlaviyo); }
  }
  new MutationObserver(queueKlaviyo).observe(document.body, { childList: true, subtree: true });
  [document.body, html].forEach(function (n) {
    new MutationObserver(queueKlaviyo).observe(n, { attributes: true, attributeFilter: ['class', 'style'] });
  });
  blockKlaviyo();

  window.TRCLP = { lp: LP, add: add, selectChip: selectChip };
})();
